import React from 'react';
import { ICollection } from '@monofront/types';
import Link from 'next/link';
import { useGlobalSearchContext } from '../../../../../context/GlobalSearchContext';

interface IListItem extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  item: ICollection;
  onClick: () => void;
}

const ListItem = ({ item, onClick, ...props }: IListItem) => {
  const { setIsGlobalSearchResultsPanelOpen } = useGlobalSearchContext();

  return (
    <Link
      key={item.objectID}
      href={`/collections/${item.handle}`}
      passHref
      legacyBehavior
    >
      <a
        onClick={() => {
          setIsGlobalSearchResultsPanelOpen(false);
          onClick();
        }}
        {...props}
      >
        <span className="tw-line-clamp-1 tw-text-start" key={item.title}>
          {item.title}
        </span>
      </a>
    </Link>
  );
};

export default ListItem;
